/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.125.1-v202604151332-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise } from 'axios';
import { getAxiosInstance, SeeqAxiosRequestConfig } from '@/requests/axios.utilities';
import { isNil, omitBy } from 'lodash';
import * as qs from 'qs';
import * as models from '../model/models';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';

export class sqMaterializedTablesApiClass {
 
   constructor() {}

  /**
   * @summary Delete rows from a materialized table
   * @param {string} tableId - The id of the table to delete rows from
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public deleteRows(
    body: models.DeleteRowsInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(tableId)) {
      throw new Error("'tableId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/materialized-tables/${encodeURIComponent(String(tableId))}/deleteRows`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.DeleteRowsOutputV1>;
  }

  /**
   * @summary Publish events to a materialized table
   * @param {string} tableId - ID of the table to publish events to
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public publishEvents(
    body: models.PublishEventsInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(tableId)) {
      throw new Error("'tableId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/materialized-tables/${encodeURIComponent(String(tableId))}/publishEvents`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.PublishEventsOutputV1>;
  }

  /**
   * @summary Recompute columns in materialized table
   * @param {string} tableId - ID of the table being recomputed
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public recomputeTable(
    body: models.RecomputeTableInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(tableId)) {
      throw new Error("'tableId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/materialized-tables/${encodeURIComponent(String(tableId))}/recomputeTable`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.RecomputeTableOutputV1>;
  }

}


export const sqMaterializedTablesApi = new sqMaterializedTablesApiClass();
